import Flexbox from '../../st-flexbox/st-flexbox';
import Icon from '../../st-icon/st-icon';
import styles from '../st-wizard.module.css';
import btnStyles from '../../st-button/st-button.module.css';
import { createMemo } from 'solid-js';

type WizardButtonProps = {
    icon: string;
    label: string;
    size?: 'medium' | 'large' | 'x-large';
    onClick: () => void;
};

export function Button(props: WizardButtonProps) {
    const sizePx = createMemo(() => {
        switch (props.size) {
            default:
            case 'medium':return 48;
            case 'large': return 64;
            case 'x-large': return 80;
        }
    })

    return <Flexbox as="button" dir="vertical" data-type="primary" middle
        class={`${btnStyles.btn} ${styles.button} ${styles[props.size ?? 'large']}`}
        onClick={props.onClick}
    >
        <div class={styles.icon}>
            <Icon src={props.icon} size={sizePx()} />
        </div>
        <span class={styles.label} style={{
            "font-size": props.size,
        }}>{props.label}</span>
    </Flexbox>
}
